import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";

import { shouldShowHotelRooms, shouldShowUnits, shouldShowSquareFeet } from "./section-property-details-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  assetTypeRef: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Asset Type",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "assetTypeRef.name"),
        Cell: tableSideColumnMapper,
        subtextMappers: [
          { map: data => defaultField(data, "assetClass.name") }
        ]
      }
    ]
  },
  assetSubtype: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Asset Subtype",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "assetSubtype"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  zoningRef: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Zoning",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "zoningRef.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  units: {
    isVisible: data => shouldShowUnits(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Units",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "units"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  squareFeet: {
    isVisible: data => shouldShowSquareFeet(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Square Feet",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "squareFeet"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  hotelRooms: {
    isVisible: data => shouldShowHotelRooms(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Rooms",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "hotelRooms"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  landSize: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Land Size (Acres)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "landSize"),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  propertyStatus: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Property Status",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "propertyStatus.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  propertyUse: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Property Use",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "propertyUse.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
};
